module.exports = __webpack_public_path__ + "static/media/checkbox-01.7e720020.png";